<template>
  <div class="text-dark mx-auto" style="width: 736px">
    <div class="mt-7 mb-20">
      <div class="flex flex-col items-center">
        <div class="my-4" style="font-size: 26px; line-height: 32px">
          {{ $t('Integrations') }}
        </div>
        <div class="text-base">
          {{ $t('frontend_groovemail_form_integrations_sublabel') }}
        </div>
      </div>
      <div class="flex flex-row mb-2 mt-4 -mx-4 px-4 border-b-1 border-grey-1">
        <gd-tabs
          :tabs="tabs"
          :current-tab="currentTab"
          :wrapper-class="'pt-4 px-0 mx-auto gs-default-tabs'"
          :tab-class="'pb-4 mr-4 gs-default-tabs-item'"
          :tab-active-class="'border-primary border-b-2 text-primary gs-default-tabs-item-active'"
          :line-class="'gs-default-tabs-active-line'"
          @onClick="handleTabChange"
        />
        </div>
        <div class="mt-2" v-if="localModel.integrations">
        <div v-if="currentTab === 'memberships'">

          <div v-if="memberships.length > 0">
            <div class="flex flex-col">
              <div class="flex flex-row-reverse w-full">
                <gd-button
                  size="auto"
                  variant="primary"
                  class="p-4"
                  @click="showPostSaleMembershipBox()"
                  >
                  {{ $t('frontend_product_step8_add_new_membership')}}
                </gd-button>
              </div>
              <div
                class="mt-6"
                v-if="localModel.integrations.memberships && localModel.integrations.memberships.length > 0"
              >
                <div
                  v-for="(
                    membership, membershipIndex
                  ) in localModel.integrations.memberships"
                  :key="membershipIndex"
                  class="flex flex-col mt-4"
                >
                  <div
                    class="flex flex-row"
                    :class="{
                      'border-t border-grey-400 border-solid pt-4':
                        membershipIndex > 0,
                    }"
                  >
                    <div class="w-1/12 mr-8">{{ $t('frontend_add_to') }}</div>
                    <div class="flex flex-row w-11/12">
                      <div class="w-3/4 flex flex-col">
                        <div class="flex flex-row">
                          <div class="font-bold mr-2">
                            {{ $t('frontend_membership') }}
                          </div>
                          <div>
                            {{
                              fetchMembershipName(
                                membership.membership_id
                              )
                            }}
                          </div>
                        </div>
                        <div class="flex flex-row">
                          <div class="font-bold mr-2">
                            {{ $t('frontend_access_level') }}
                          </div>
                          <div>
                            {{
                              fetchAccessLevelName(
                                membership.membership_id,
                                membership.secret_key
                              )
                            }}
                          </div>
                        </div>
                      </div>
                      <div class="w-1/4 flex flex-row justify-end pr-4">
                        <gd-button
                          size="icon"
                          variant="primary"
                          :title="$t('frontend_groovesell_delete_membership')"
                          class="mr-2"
                          @click="deleteMembership(membershipIndex)"
                        >
                          <DeleteIcon class="h-4 w-4"/>
                        </gd-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="mt-6">
                <label class="text-grey-dark">
                  {{ $t('frontend_no_memberships_added_message') }}
                </label>
              </div>
            </div>
          </div>
          <div v-else class="mt-6">
            <label class="text-grey-dark">{{
              $t('frontend_product_step8_no_memberships_added')
            }}</label>
          </div>
        </div>

        <div v-else-if="currentTab === 'integrations'">
                          <div
                  v-if="
                    pluginSiteData.integrations.length > 0 &&
                    availableIntegrations.length > 0
                  "
                >
                  <div class="flex flex-col">
                    <div class="flex flex-row-reverse w-full">
                      <gd-button
                        size="auto"
                        variant="primary"
                        class="p-4"
                        @click="showIntegrationsModal()"
                      >
                        <PlusIcon class="h-6 w-6" slot="prepend" />
                        {{ $t('frontend_product_step8_add_new') }}
                      </gd-button>
                    </div>
                    <div
                      v-if="localModel.integrations.integrations && localModel.integrations.integrations.length > 0"
                      class="mt-6"
                    >
                      <div
                        v-for="(
                          integration, integrationIndex
                        ) in localModel.integrations.integrations"
                        :key="integrationIndex"
                        class="flex flex-col mt-4"
                      >
                        <div
                          class="flex flex-row"
                          :class="{
                            'border-t border-grey-400 border-solid pt-4':
                              integrationIndex > 0,
                          }"
                        >
                          <div class="w-1/12 mr-8">
                            {{ $t('frontend_add') }} {{ $t('frontend_to') }}
                          </div>
                          <div class="flex flex-row w-11/12">
                            <div class="w-3/4 flex flex-col">
                              <div class="flex flex-row">
                                <div class="font-bold mr-2">
                                  {{ $t('frontend_product_step8_type') }}
                                </div>
                                <div>
                                  {{
                                    integration.platform
                                      .charAt(0)
                                      .toUpperCase() +
                                    integration.platform.slice(1)
                                  }}
                                </div>
                              </div>
                              <div
                                v-for="(
                                  integrationConfig,
                                  integrationConfigIndex
                                ) in integration.config"
                                :key="integrationConfigIndex"
                                class="flex flex-row"
                              >
                                <div class="font-bold mr-2">
                                  {{ integrationConfig.label }} :
                                </div>
                                <div>{{ integrationConfig.name }}</div>
                              </div>
                            </div>
                            <div class="w-1/4 flex flex-row justify-end pr-4">
                              <gd-button
                                size="icon"
                                variant="primary"
                                :title="$t('frontend_groovesell_delete_integration')"
                                class="mr-2"
                                @click="
                                  deleteIntegrationModal(
                                    integrationIndex
                                  )
                                "
                              >
                                <DeleteIcon class="h-4 w-4"/>
                              </gd-button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else class="mt-6">
                      <label class="text-grey-dark">
                        {{ $t('frontend_no_integrations_added_message') }}
                      </label>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <label class="text-grey-dark">{{
                    $t('frontend_product_step8_no_integrations_added')
                  }}</label>
                </div>

        </div>
        <div v-else-if="currentTab === 'webHook' && localModel.integrations.webhooks">
          <div
                >
                  <div class="flex flex-row-reverse w-full">
                    <gd-button
                      size="auto"
                      variant="primary"
                      class="p-4"
                      @click="showWebhooksModal()"
                      >{{ $t('frontend_product_step8_no_integrations_add_new_webhook') }}
                    </gd-button>
                  </div>
                  <div
                    class="mt-6"
                    v-if="localModel.integrations.webhooks && localModel.integrations.webhooks.length > 0"
                  >

                  <div
                    v-for="(webhook, index) in localModel.integrations.webhooks"
                    :key="index"
                    class="flex flex-col w-full mb-6"
                  >
                    <div
                    :class="{
                      'border-t border-grey-400 border-solid pt-4':
                        index > 0,
                    }"
                  >
                    <div class="w-full mr-5" style="white-space:nowrap">{{ $t('frontend_groovewebinar_moderator_chat_send_to') }}</div>
                    <div class="flex flex-row w-full">
                      <div class="w-11/12 flex flex-col">
                        <div class="flex flex-row">
                          <div class="font-bold mr-2">
                            {{ $t('frontend_groovemail_forms_step5_url') }}:
                          </div>
                          <div :title="webhook.link" style="text-overflow: ellipsis; overflow: hidden; white-space:nowrap">
                            {{ webhook.link }}
                          </div>
                        </div>
                      </div>
                      <div class="w-1/12 flex flex-row justify-end -mt-2">
                        <gd-button
                          size="icon"
                          variant="primary"
                          :title="$t('frontend_groovesell_delete_webhook')"
                          class="mr-2"
                          @click="deleteWebhook(index)"
                        >
                          <DeleteIcon class="h-4 w-4"/>
                        </gd-button>
                      </div>
                    </div>
                  </div>
                  </div>
                </div>
                <div v-else class="mt-6">
                  <label class="text-grey-dark">
                    {{ $t('frontend_no_webhooks_added_message') }}
                  </label>
                </div>
                </div>
        </div>

        <div v-else-if="currentTab === 'files'">

          <div v-if="files.length > 0">
            <div class="flex flex-col">
              <div class="flex flex-row-reverse w-full">
                <gd-button
                  size="auto"
                  variant="primary"
                  class="p-4"
                  @click="openAddItemPopup"
                >
                  {{ $t('frontend_product_step8_add_new_membership_file') }}
                </gd-button>
              </div>
              <div
                class="mt-6"
                v-if="localModel.integrations.files && localModel.integrations.files.length > 0"
              >
                <div
                  v-for="(
                    file, fileIndex
                  ) in localModel.integrations.files"
                  :key="fileIndex"
                  class="flex flex-col mt-4"
                >
                  <div
                    class="flex flex-row"
                    :class="{
                      'border-t border-grey-400 border-solid pt-4':
                        fileIndex > 0,
                    }"
                  >
                    <div class="w-1/12 mr-8">
                      {{ $t('frontend_send') }}
                    </div>
                    <div class="flex flex-row w-11/12">
                      <div class="w-3/4 flex flex-col">
                              <div class="flex flex-row">
                                <div class="font-bold mr-2">
                                  {{ $t('frontend_name') }}
                                </div>
                                <div>
                                  {{ fetchMemberFileName(file.file_id) }}
                                </div>
                              </div>
                              <div class="flex flex-row">
                                <div class="font-bold mr-2">
                                  {{ $t('frontend_file_name') }}
                                </div>
                                <div>
                                  {{
                                    fetchMemberOriginalFileName(file.file_id)
                                  }}
                                </div>
                              </div>
                              <div class="flex flex-row">
                                <div class="font-bold mr-2">
                                  {{ $t('frontend_size') }}
                                </div>
                                <div>
                                  {{ fetchMemberFileSize(file.file_id) }}
                                </div>
                              </div>
                            </div>
                      <div class="w-1/4 flex flex-row justify-end pr-4">
                        <gd-button
                          size="icon"
                          variant="primary"
                          :title="$t('frontend_groovesell_delete_file')"
                          class="mr-2"
                          @click="deleteFile(fileIndex)"
                        >
                          <DeleteIcon class="h-4 w-4"/>
                        </gd-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="mt-6">
                <label class="text-grey-dark">
                  {{ $t('frontend_no_files_added_message') }}
                </label>
              </div>
            </div>
          </div>
          <div v-else class="mt-6">
            <label class="text-grey-dark">
              {{ $t('frontend_groovemail_product_step8_no_memberships_added') }}
            </label>
          </div>


        </div>
      </div>
      <gd-modal
        name="add-membership-modal"
        :title="$t('frontend_groovesell_add_membership')"
        width="80%"
      >
        <div class="flex flex-col px-4">
          <div class="mt-4">
            <div class="-mt-4">
              <div class="flex flex-row w-full">
                <div class="w-1/2 flex flex-col w-full mt-4 mr-4">
                  <label
                    class="font-semibold text-sm text-grey-700 mb-2 text-left"
                    >{{ $t('frontend_select') }}
                    {{ $t('frontend_membership') }}</label
                  >
                  <select
                    v-model="temp_membership.membership_id"
                    class="w-full h-10 outline-none rounded-lg px-4 border border-grey-200"
                  >
                    <option value="">
                      {{ $t('frontend_select') }} {{ $t('frontend_membership') }}
                    </option>
                    <option
                      v-for="membership in this.memberships"
                      :key="membership.id"
                      :value="membership.id"
                      :data-name="membership.name"
                    >
                      {{ membership.name }}
                    </option>
                  </select>
                </div>

                <div class="w-1/2 flex flex-col w-full mt-4">
                  <label
                    class="font-semibold text-sm text-grey-700 mb-2 text-left"
                    >{{ $t('frontend_select') }}
                    {{ $t('frontend_access_level') }}</label
                  >
                  <select
                    v-model="temp_membership.secret_key"
                    class="w-full h-10 outline-none rounded-lg px-4 border border-grey-200"
                  >
                    <option value="">
                      {{ $t('frontend_select') }}
                      {{ $t('frontend_access_level') }}
                    </option>
                    <option
                      v-for="accessLevel in membershipsAccessLevels"
                      :key="accessLevel.secret_key"
                      :value="accessLevel.secret_key"
                      :data-name="accessLevel.name"
                    >
                      {{ accessLevel.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="flex flex-row w-full mb-6 mt-4 justify-end">
            <gd-button
              variant="primary"
              class="font-semibold"
              size="auto"
              :disabled="temp_membership.membership_id == 0 || temp_membership.secret_key == ''"
              @click="addMembership"
            >
              {{ $t('frontend_add') }}
            </gd-button>
          </div>
        </div>
      </gd-modal>
      <gd-modal
        name="add-new-mail-integration-modal"
        :title="$t('frontend_product_step5_add_new_integration')"
        :no-overflow="true"
      >
        <div class="flex flex-col m-8">
          <div class="flex flex-col w-full mb-6">
            <div class="w-full flex flex-col mr-2">
              <label class="font-semibold text-sm text-grey-700 mb-2">{{
                $t('frontend_product_step8_type')
              }}</label>
              <gd-dropdown
                :v-bind="integrationType"
                :value="integrationType"
                :options="availableIntegrations"
                @change="setValue($event)"
                @keyup="setValue($event)"
                size="full"
                variant="base"
              />
            </div>
            <div
              v-if="integrationType && integrationType != ''"
              class="w-full flex flex-col mr-2 mt-4"
            >
              <config-menu
                :in-styles-panel="true"
                :key="configMenuKey"
                :initial-values="componentConfigValues"
                :plugin-id="pluginId"
                :resources-path="resourcesPath"
                :server-path="serverPath"
                :plugin="integrationType"
                :app-data="pluginSiteData"
                layout="vertical"
                :is-dark="false"
                :show-button-borders="false"
                :show-notifications-on-save="false"
                :opened-from="'groovesell'"
                :btn-label="$t('frontend_sites_integration_modal_add_integration')"
                @update="addIntegration"
                @menu-updated="configMenuItemsUpdated"
              ></config-menu>
            </div>
          </div>
        </div>
      </gd-modal>
      <gd-modal
      name="add-webhook-modal"
      :title="$t('frontend_product_step8_no_integrations_add_new_webhook')"
    >
      <div class="flex flex-col px-4">
        <div class="mt-4">
          <div class="-mt-4">
            <div class="w-full">
              <div class="py-4 px-1">
                <label class="font-semibold text-sm text-grey-700 mb-2">
                  {{ $t('frontend_product_step8_webhook_url') }}
                </label>
                <div class="flex flex-row w-full">
                  <div class="w-full">
                    <text-input
                      variant="base"
                      v-model="temp_webhook.link"
                      :validator="$v.temp_webhook.link"
                      :shouldValidateURL="true"
                      :placeholder="$t('frontend_product_step8_webhook_url')"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-row w-full mb-6 mt-2 justify-end">
          <gd-button
            variant="primary"
            class="font-semibold"
            size="auto"
            
            @click="addWebhook"
          >
            {{ $t('frontend_add') }}
          </gd-button>
        </div>
      </div>
      </gd-modal>

      <file-library
        :allowedFiles="'*'"
        :key="selectedFile.id"
        ref="fileLibrary"
        :value="selectedFile"
        @selected="
        updateItem({
          title: $event.name,
          id: $event.id,
        })
        "
        @opened="fileLibraryOpened"
      />


      <confirm-modal
        :ref="`confirmation-delete-integration`"
        :name="`confirmation-delete-integration`"
        :buttonText="$t('frontend_delete')"
        :cancelText="$t('frontend_cancel')"
        :confirmMessage="this.$t('frontend_bouses_delete_bonus_title')"
        :messageContent="this.$t('frontend_non_revertable')"
        @confirm="deleteIntegration"
        @close="closeDeleteCategoryModal"
      />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import auth from '@groovepages/gd-lib/auth';
import ConfigMenu from '@groovepages/gd-ui-kit/components/PluginMenu';
import FileLibraryMixin from '@groovepages/groovemember-ui-kit/components/version-2/common/canvas/custom-popup/file-library/mixin';
import { required, url } from 'vuelidate/lib/validators';
import showAlert from '@/components/sweet-alert-popup.js';
import themeConfig from '@/theme/themeConfig.js';

// import icons
import DeleteIcon from '@/assets/images/icons/new/trash_new.svg';
import PlusIcon from '@/assets/images/icons/new/plus-small_new.svg';

export default {
  name: 'Step5',
  props: {
    model: {
      required: true,
    },
  },
  mixins: [FileLibraryMixin],

  data() {
    return {
      changesMadeInStep: false,
      hiddenKey: '',
      localModel: this.model,
      widgetUrl: '',
      currentTab: 'webHook',

      memberships: [],
      files: [],
      temp_membership: {
        membership_id: '',
        secret_key: ''
      },
      temp_webhook: {
        link: '',
      },

      integrationType: '',
      componentConfigValues: {},
      pluginId: '',
      pluginMenuItems: [],
      configMenuKey: 1,

      integrationIndex: null,

      tabs: [
        {
          title: this.$t('frontend_groovemember_membership_sidebar_memberships'),
          value: 'memberships',
        },
        {
          title: this.$t('frontend_product_step8_integrations'),
          value: 'integrations',
        },
        {
          title: this.$t('frontend_product_step8_webhook'),
          value: 'webHook',
        },
        {
          title: this.$t('frontend_product_step8_files'),
          value: 'files',
        },
      ],
    };
  },
  

  validations: {
    temp_webhook: {
      link: {
        required,
        url,
      },
    },
  },

  components: {
    ConfigMenu,
    DeleteIcon,
    PlusIcon,
  },
  computed: {
    membershipsAccessLevels() {
      if(this.temp_membership.membership_id > 0){
        return this.memberships.find(i => i.id === this.temp_membership.membership_id).access_level;
      }
      return [];
    },
    pluginSiteData() {
      return this.$store.getters.pluginSiteSettings;
    },
    serverPath() {
      return `${window.gdEnv.VUE_APP_API_URL}/groovedigital/plugins/call/`;
    },
    resourcesPath() {
      return `${window.gdEnv.VUE_APP_STORAGE_URL}/plugins/`;
    },
    availableIntegrations() {
      const user = auth.authenticatedUser();
      if (user.metadata && user.metadata.integrations) {
        const integrations = [];
        user.metadata.integrations.map((value) => {
          const integrationType = value.type.split('-')[0];
          const integrationPlugin = `${integrationType}-component`;
          if (
            integrations.findIndex((x) => x.value === integrationPlugin) === -1
          ) {
            integrations.push({
              text:
                integrationType.charAt(0).toUpperCase() +
                integrationType.slice(1),
              value: integrationPlugin,
            });
          }
        });

        return integrations;
      }
      return [];
    },
  },
  watch: {
    localModel: {
      deep: true,
      handler() {
        this.changesMadeInStep = true;
      }
    },
  },

  async mounted() {
    // show loader
    this.showLoader();

    try {
      const groovememberUrl = window.config.apiUrl.substr(
        0,
        window.config.apiUrl.lastIndexOf('/')
      );
      const result = await axios.get(
        `${groovememberUrl}/groovemember/memberships`
      );
      this.memberships = result.data;
      const resultFiles = await axios.get(
        `${groovememberUrl}/groovemember/membership/file`
      );
      this.files = resultFiles.data.data;
      if(!this.localModel.integrations){
        this.$set(this.localModel, 'integrations', {});
      }
      if(!this.localModel.integrations.webhooks){
        this.$set(this.localModel.integrations, 'webhooks', []);
      }
      if(!this.localModel.integrations.memberships){
        this.$set(this.localModel.integrations, 'memberships', []);
      }
      if(!this.localModel.integrations.files){
        this.$set(this.localModel.integrations, 'files', []);
      }

      // hide loader
      this.hideLoader();
    } catch (error) {
      this.requestErrorAlert(error.response?.data?.error);
    }

  },

  methods: {
    // show loader
    showLoader() {
      this.$emit('showLoader');
    },

    // hide loader
    hideLoader() {
      this.$emit('hideLoader');
    },

    // error message for the request field
    async requestErrorAlert(error) {
      // hide the loader
      this.hideLoader();
      
      await showAlert({
        iconType: 'alert-error',
        html : `
          <style>.swal2-cancel { color: ${themeConfig.appPrimaryColorInvert} !important; }</style>
          <p class="text-sm text-deep-dark mb-3">${error || this.$t('frontend_backend_error') }</p>
        `,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonColor: themeConfig.appPrimaryColor,
        confirmButtonText: this.$t('frontend_close'),
      });
    },

    checkChangesMadeOnThisStep() {
      return this.changesMadeInStep;
    },
    configMenuItemsUpdated(data) {
      this.pluginMenuItems = data.menuItems;
    },
    fetchMemberFileName(fileId) {
      const file = this.files.find((obj) => {
        return obj.id === fileId;
      });

      if (file) {
        return file.name;
      }
      return 'N/A';
    },

    fetchMemberOriginalFileName(fileId) {
      const file = this.files.find((obj) => {
        return obj.id === fileId;
      });

      if (file) {
        return file.original_name;
      }
      return 'N/A';
    },

    fetchMemberFileSize(fileId) {
      const file = this.files.find((obj) => {
        return obj.id === fileId;
      });

      if (file) {
        return file.size;
      }
      return 'N/A';
    },
    showPostSaleMembershipBox() {
      this.$root.$emit('modal-open', 'add-membership-modal');
    },
    showIntegrationsModal() {
      this.integrationType = '';
      this.$root.$emit('modal-open', 'add-new-mail-integration-modal');
    },
    showWebhooksModal() {
      this.$root.$emit('modal-open', 'add-webhook-modal');
    },
    setValue(value) {
      this.integrationType = value;
      this.pluginId = '';
      this.componentConfigValues = {};
      this.configMenuKey = this.configMenuKey + 1;
    },
    fetchMembershipName(membershipId) {
      const membership = this.memberships.find((obj) => {
        return obj.id === membershipId;
      });

      if (membership) {
        return membership.name;
      }
      return 'N/A';
    },
    fetchAccessLevelName(membershipId, accessLevelSecretKey) {
      const membership = this.memberships.find((obj) => {
        return obj.id === membershipId;
      });

      if (membership) {
        const accessLevels = membership.access_level;

        if (accessLevels) {
          const accessLevel = accessLevels.find((obj) => {
            return obj.secret_key === accessLevelSecretKey;
          });

          if (accessLevel) {
            return accessLevel.name;
          }
          return 'N/A';
        }
        return 'N/A';
      }
      return 'N/A';
    },
    addIntegration(data) {
      const integrationConfig = data.config;
      const self = this;

      const integrationInfo = [];

      for (const index in integrationConfig) {
        const value = integrationConfig[index];
        
        if (value) {
          self.pluginMenuItems.forEach((menuValue) => {
            if (menuValue.key === index) {
              const { options } = menuValue;

              let objChecker = false;
              let correspondingOption = value;

              console.log(index, options, objChecker);

              if (options) {
                objChecker = options.some((val) => {
                  return typeof val === 'object';
                });

                if (objChecker) {
                  correspondingOption = options.find((o) => o.value === value);
                }
              }

              const singleIntegrationField = {};
              singleIntegrationField.index = index;
              singleIntegrationField.value = value;
              singleIntegrationField.label = menuValue.label;

              if (objChecker) {
                singleIntegrationField.name = correspondingOption.text;
              } else {
                singleIntegrationField.name = value;
              }

              integrationInfo.push(singleIntegrationField);
            }
          });
        }
      }

      const completeIntegrationInfo = {};
      completeIntegrationInfo.platform = this.integrationType.split('-')[0];
      completeIntegrationInfo.config = integrationInfo;

      if (this.localModel.integrations.integrations) {
        this.localModel.integrations.integrations.push(completeIntegrationInfo);
      } else {
        this.localModel.integrations.integrations = [];
        this.localModel.integrations.integrations.push(completeIntegrationInfo);
      }

      this.$root.$emit('modal-close', 'add-new-mail-integration-modal');
    },
    addMembership() {
      this.localModel.integrations.memberships.push(this.temp_membership);
      this.temp_membership = {membership_id: '', secret_key: ''};
      this.$root.$emit('modal-close', 'add-membership-modal');
    },
    updateItem(i) {
      this.localModel.integrations.files.push({file_id: i.id});
    },
    addWebhook() {

      // Validate the website URL
      this.$v.temp_webhook.link.$touch();

      // If the URL is invalid stop the function
      if (this.$v.temp_webhook.link.$invalid) {
        return;
      }

      this.localModel.integrations.webhooks.push(this.temp_webhook);
      this.temp_webhook = {link: ''};
      this.$root.$emit('modal-close', 'add-webhook-modal');
    },
    deleteFile(index) {
      this.localModel.integrations.files.splice(
        index,
        1
      );
    },

    // open delete integration modal
    async deleteIntegrationModal(index) {
      // set the integration index
      this.integrationIndex = index;

      // open the modal
      this.$refs[`confirmation-delete-integration`].open();
    },

    // close delete integration modal
    closeDeleteCategoryModal() {
      // reset the integration index
      this.integrationIndex = null;

      // close the modal
      this.$refs[`confirmation-delete-integration`].close();
    },

    deleteIntegration() {
      this.localModel.integrations.integrations.splice(
        this.integrationIndex,
        1
      );
    },

    deleteWebhook(index) {
      this.localModel.integrations.webhooks.splice(
        index,
        1
      );
    },
    deleteMembership(index) {
      this.localModel.integrations.memberships.splice(
        index,
        1
      );
    },
    handleTabChange(newTab) {
      this.currentTab = newTab;
    },
    validate() {
      const isValid = true;
      this.$emit('on-validate', isValid);
      return isValid;
    },
    validateForSaveAndExit() {
      return true;
    },

  },
};
</script>
<style>
.add-new-mail-integration-modal .integration-select-config-menu div span{
  padding-right: 8px;
}
</style>
